export function platformRefreshStatusTagColor(status?: string | null) {
  const value = String(status || '').toLowerCase()
  if (value === 'failed') return 'red'
  if (value === 'refreshed' || value === 'connected') return 'green'
  if (value === 'refreshing') return 'blue'
  return 'gold'
}

export function formatDateTime(value?: string | null) {
  if (!value) return 'N/A'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value
  return parsed.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function formatDate(value?: string | null) {
  if (!value) return 'N/A'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value
  return parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

